export const isValidUrl = (url: string) => {
  const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,4}(:\d+)?(\/.*)?$/i;
  return urlRegex.test(url);
};
